import { render, staticRenderFns } from "./MenuSet.vue?vue&type=template&id=ffad9df6&"
import script from "./MenuSet.vue?vue&type=script&lang=js&"
export * from "./MenuSet.vue?vue&type=script&lang=js&"
import style0 from "./MenuSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports